import baseApi from './baseApi';

export interface MeetingParticipant {
  displayName: string | null;
  email: string | null;
}

export interface MeetingOverview {
  name: string;
  title: string | null;
  startTime?: string;
  endTime?: string;
  meetingUri: string | null;
  participants: MeetingParticipant[];
  docText: string | null;
}

export interface GmailMessage {
  id: string | null;
  from: string | null;
  date: string | null;
  body: string | null;
}

export interface GmailEmail {
  id: string | null;
  subject: string | null;
  from: string | null;
  date: string | null;
  messages: GmailMessage[];
}

const googleWorkspaceApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getMeetOverview: build.query({
      query: () => ({ url: '/admin/google-workspace/meet/overview', method: 'GET' }),
      transformResponse: (response: { meetings?: MeetingOverview[] }) => response.meetings ?? [],
    }),
    getGmailOverview: build.query({
      query: () => ({ url: '/admin/google-workspace/gmail/overview', method: 'GET' }),
      transformResponse: (response: { emails?: GmailEmail[] }) => response.emails ?? [],
    }),
    getBusinessEmailConnectUrl: build.query<string, number>({
      query: (businessUnitId) => ({
        url: `/admin/google-workspace/business-email/connect?businessUnitId=${businessUnitId}`,
        method: 'GET',
      }),
      transformResponse: (response: { url: string }) => response.url,
    }),
  }),
  overrideExisting: false,
});

export const { useLazyGetMeetOverviewQuery, useLazyGetGmailOverviewQuery, useLazyGetBusinessEmailConnectUrlQuery } =
  googleWorkspaceApi;
